import { render, staticRenderFns } from "./noticeIndex.vue?vue&type=template&id=4b555e8e"
import script from "./noticeIndex.vue?vue&type=script&lang=js"
export * from "./noticeIndex.vue?vue&type=script&lang=js"
import style0 from "./noticeIndex.vue?vue&type=style&index=0&id=4b555e8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports